import { render } from "./DetalharOpcaoAvaliacao.vue?vue&type=template&id=282c3ad2&scoped=true"
import script from "./DetalharOpcaoAvaliacao.vue?vue&type=script&lang=js"
export * from "./DetalharOpcaoAvaliacao.vue?vue&type=script&lang=js"

import "./DetalharOpcaoAvaliacao.vue?vue&type=style&index=0&id=282c3ad2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282c3ad2"]])

export default __exports__